import React from 'react';
import { DatePicker, Space } from 'antd';
import { utcMoment } from '@src/components/usage-dashboard/utils';
import GranularityPicker from './GranularityPicker';
import { Kebab } from '../../KebabIcon/Kebab';

const { RangePicker } = DatePicker;

const UsageDatePicker = ({ onRangeChange, defaultValue }) => {
  const disabledDate = (current) => {
    const calendarDateMoment = utcMoment(current);
    return calendarDateMoment && calendarDateMoment > utcMoment().endOf('day');
  };

  const rangePresets: any = [
    {
      label: 'Yesterday',
      value: [
        utcMoment().subtract(1, 'days').startOf('day'),
        utcMoment().subtract(1, 'days').endOf('day'),
      ],
    },
    {
      label: 'Last Week',
      value: [
        utcMoment().subtract(1, 'week').startOf('week'),
        utcMoment().subtract(1, 'week').endOf('week'),
      ],
    },
    { label: 'This Month', value: [utcMoment().startOf('month'), utcMoment().startOf('day')] },
    {
      label: 'Last Month',
      value: [
        utcMoment().subtract(1, 'month').startOf('month'),
        utcMoment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      label: 'Past 7 Days',
      value: [
        utcMoment().subtract(7, 'days').startOf('day'),
        utcMoment().subtract(1, 'day').endOf('day'),
      ],
    },
    {
      label: 'Past 30 Days',
      value: [
        utcMoment().subtract(30, 'days').startOf('day'),
        utcMoment().subtract(1, 'day').endOf('day'),
      ],
    },
    {
      label: 'Past 90 Days',
      value: [
        utcMoment().subtract(90, 'days').startOf('day'),
        utcMoment().subtract(1, 'day').endOf('day'),
      ],
    },
    {
      label: 'Past 1 Year',
      value: [
        utcMoment().subtract(1, 'year').startOf('day'),
        utcMoment().subtract(1, 'day').endOf('day'),
      ],
    },
  ];
  return (
    <Space>
      <GranularityPicker></GranularityPicker>
      <RangePicker
        presets={rangePresets}
        onChange={onRangeChange}
        disabledDate={disabledDate}
        defaultValue={defaultValue}
        style={{ backgroundColor: '#e9edf0' }}
      />
      <Kebab></Kebab>
    </Space>
  );
};

export default UsageDatePicker;
